import {Autocomplete, Button, Field, FieldsContainer, Form, PageHeader, TextField} from "common";
import I18n from "i18n-js";
import {DialogActions, DialogContent} from "@mui/material";
import useInviteForm from "./useInviteForm";
import React from "react";
import {ROLES} from "../../../../app/constants";
import useAccess from "../../../profile/useAccess";
import {invite, inviteOptions} from "./inviteAPI";

export default function InviteForm({onModalClose}: { onModalClose: Function | undefined }) {
  const {
    item,
    errors,
    options,
    process,
    onChange,
    onClose,
    loading,
  } = useInviteForm({onModalClose});

  const access = useAccess();

  return (
    <>
      <PageHeader title={I18n.t("InviteForm.title")} onClose={onClose}/>
      <DialogContent>
        <Form
          item={item}
          errors={errors}
          onChange={onChange}
          translationCategory="InviteForm.attributes"
        >
          <FieldsContainer>
            <Field xs={12}>
              <TextField
                id={"email"}
                onEnter={process}
              />
            </Field>
            <Field fullWidth>
              <Autocomplete
                id="role"
                options={options.role}
                disabled={!access.hasRoles(ROLES.OWNER)}
              />
            </Field>
            {item.role === ROLES.BASIC
              ? (
                <Field fullWidth>
                  <Autocomplete
                    id="permissions"
                    options={options.permissions}
                    multiple
                    getOptionDisabled={(option: any) => {
                      const selectedOptions = item.permissions;
                      const allOptions = options.permissions;
                      const currentPermission = option.value;
                      const match = currentPermission.match(/^(manage|view)(.+)$/);
                      const [type, permission] = [match[1], match[2]];
                      const otherType = type == "view"
                        ? "manage"
                        : "view";
                      const otherPermissionValue = otherType + permission;

                      let otherTypeFound = false;
                      allOptions.forEach((option) => {
                        if (option.value == otherPermissionValue) {
                          otherTypeFound = true;
                        }
                      });

                      if (!otherTypeFound) {
                        return false;
                      }

                      return selectedOptions && type == "view" && selectedOptions.includes(otherPermissionValue);
                    }}
                  />
                </Field>
              )
              : null
            }
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("InviteForm.send")}
          onClick={() => process()}
          loading={loading}
        />
      </DialogActions>
    </>
  );
}